import { TextareaAutosize } from "@mui/material";
import React from "react";

function TextareaAutoSize(props) {
  const { placeholder, minRows } = props;
  return (
    <>
      <TextareaAutosize
        aria-label="body message"
        placeholder={placeholder || "Body Message ...."}
        style={{ width: "auto" }}
        minRows={minRows || "6"}
      />
    </>
  );
}

export default TextareaAutoSize;
